/*
  سدر الخليج: سكربت صفحة المقال (BLG-23)، يُحمَّل في قسم sedr-main-article وحده.
  المقال يُقرأ كاملًا دون هذا السكربت؛ هو يحسّن العرض فقط:
  1. إصلاح صور المنتجات المكسورة من صفحة المنتج (منقول من قسم blog_reference_styles).
  2. الجداول في غلاف يتمرّر أفقيًا على الجوال.
  3. «من منتجاتنا»: الصورة والسطر الذي يليها بطاقة واحدة.
  4. تعليم قائمتي «اقرأ أيضًا» و«المراجع» وسطري المؤلف («إعداد وتحرير» أو «كتبه») و«آخر مراجعة». وفي المراجع: كل مرجع باتجاه لغته ورقمه بجانبه،
     وأكثر تواريخ الاطلاع تكرارًا يُعرض سطرًا واحدًا تحت القائمة، وما خالفه تحت مرجعه. والقائمة مطوية تحت عنوانها،
     وتُفتح وحدها حين يُنقر رقم إحالة في المقال أو يُفتح رابط إلى مرجع.
  5. جدول المحتويات أكورديون Impact (منقول من قسم blog_reference_styles).
  6. قائمة جانبية للأقسام على الشاشات العريضة: شرطة لكل قسم رئيسي في الفهرس، يتميّز منها القسم الحالي،
     وتظهر أسماؤها عند مرور المؤشر. تظهر بعد تجاوز الفهرس وتختفي آخر المقال، ولا تُبنى إن قلّت الأقسام عن أربعة.
     وعلى الجوال زر مستدير فوق زر «إلى الأعلى» تنفتح منه قائمة الأقسام، يتميّز فيها القسم الحالي.
  7. الأسئلة الشائعة (details متتالية) صندوق أكورديون Impact كقسم FAQ في القالب.
  8. الرسوم التفاعلية (BLG-25، M61): figure.sedr-fig[data-sedr-chart="layers"] يُبنى مكان صورته رسمٌ بشكلها وألوانها
     يُسحب عليه الإصبع أو المؤشر فيبيّن ما بقي من طبقات العطر في كل وقت. والصورة هي النسخة الثابتة،
     وتبقى في الصفحة الإنجليزية وحين لا يعمل السكربت.
  9. إن عرض القسم مقالات «اقرأ أيضًا» بطاقاتٍ آخر الصفحة (.sedr-more[data-related]) حُذفت قائمتها النصية وعنوانها من المقال،
     فيسقط من الفهرس ومن قائمة الأقسام.
  10. التاريخ الهجري انتقل إلى assets/sedr-hijri.js ليعمل في صفحة المدونة كذلك.
  11. المشاركة: زر نسخ الرابط ([data-sedr-copy]) ويُعلن «نُسخ الرابط» بجانب الأزرار، وزر المشاركة من النظام
     ([data-sedr-native-share]) يظهر إن دعمه المتصفح.
  12. «هل أفادك هذا المقال؟» (BLG-33، M72): يُظهر الزرين (مخفيان دون السكربت)، ويرسل الإجابة إلى Microsoft Clarity
     وإلى أحداث Shopify (sedr_article_feedback)، ويحفظها في المتصفح فيبقى الشكر مكان الزرين عند العودة إلى المقال.
*/
(function () {
  function init() {
    shareButtons();
    helpful();
    var prose = document.querySelector('.sedr-article .sedr-prose');
    if (!prose) return;
    wrapTables(prose);
    productCards(prose);
    repairImages(prose);
    markSections(prose);
    dropRelated(prose);
    buildToc(prose);
    buildFaq(prose);
    layersCharts(prose);
    buildRail(prose);
  }

  function shareButtons() {
    if (navigator.share) {
      document.querySelectorAll('.sedr-article [data-sedr-native-share]').forEach(function (li) { li.hidden = false; });
    }
    document.querySelectorAll('.sedr-article [data-sedr-copy]').forEach(function (btn) {
      var status = btn.closest('.sedr-share') && btn.closest('.sedr-share').querySelector('.sedr-share__status');
      var timer;
      function done() {
        btn.classList.add('is-copied');
        if (status) status.textContent = btn.getAttribute('data-done') || '';
        clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, 2500);
      }
      function fallback(url) {
        var ta = document.createElement('textarea');
        ta.value = url;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { if (document.execCommand('copy')) done(); } catch (e) {}
        document.body.removeChild(ta);
      }
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-sedr-copy');
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).then(done, function () { fallback(url); });
        } else {
          fallback(url);
        }
      });
    });
  }

  function helpful() {
    var box = document.querySelector('.sedr-article [data-sedr-helpful]');
    if (!box) return;
    var KEY = 'sedr-helpful';
    var id = box.getAttribute('data-sedr-helpful');
    var thanks = box.querySelector('.sedr-helpful__thanks');
    var saved = {};
    try { saved = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) {}

    function answered() {
      box.classList.add('is-answered');
      thanks.textContent = thanks.getAttribute('data-thanks') || '';
    }

    box.hidden = false;
    if (saved[id]) return answered();

    box.querySelectorAll('[data-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (box.classList.contains('is-answered')) return;
        var answer = btn.getAttribute('data-answer');
        var handle = box.getAttribute('data-handle') || '';
        /* إن لم يكن Clarity قد حُمّل بعدُ فالإجابة تنتظر في طابوره (الطريقة نفسها في شيفرته المعتمدة)، ولا يضر إن لم يُحمَّل */
        try {
          window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
          window.clarity('set', 'sedr_helpful', answer);
          window.clarity('set', 'sedr_article', handle);
          window.clarity('event', 'article_helpful_' + answer);
        } catch (e) {}
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('sedr_article_feedback', {
              article_id: id, handle: handle, answer: answer, locale: document.documentElement.lang || ''
            });
          }
        } catch (e) {}
        saved[id] = answer;
        try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
        answered();
        thanks.setAttribute('tabindex', '-1');
        thanks.focus();
      });
    });
  }

  function repairImages(prose) {
    prose.querySelectorAll('img').forEach(function (img) {
      function hide(el) {
        (el.closest('a') || el).style.display = 'none';
        var card = el.closest('.sedr-product');
        if (card) card.classList.add('sedr-product--noimg');
      }
      function repair() {
        if (img.dataset.repaired) { hide(img); return; }
        img.dataset.repaired = '1';
        var card = img.closest('.sedr-product');
        var link = img.closest('a[href*="/products/"]') || (card && card.querySelector('a[href*="/products/"]'));
        var m = link ? link.getAttribute('href').match(/\/products\/([^\/?#]+)/) : null;
        if (!m) { hide(img); return; }
        fetch('/products/' + m[1] + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            if (p && p.featured_image) {
              img.removeAttribute('srcset');
              img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=800';
            } else { hide(img); }
          })
          .catch(function () { hide(img); });
      }
      img.addEventListener('error', repair);
      if (img.complete && img.naturalWidth === 0) repair();
    });
  }

  function wrapTables(prose) {
    prose.querySelectorAll('table').forEach(function (table) {
      if (table.parentNode.classList.contains('sedr-table-scroll')) return;
      var box = document.createElement('div');
      box.className = 'sedr-table-scroll';
      box.setAttribute('tabindex', '0');
      box.setAttribute('role', 'region');
      var label = table.querySelector('caption');
      for (var el = table.previousElementSibling; !label && el; el = el.previousElementSibling) {
        if (/^H[2-4]$/.test(el.tagName)) label = el;
      }
      var en = (document.documentElement.lang || '').indexOf('en') === 0;
      box.setAttribute('aria-label', label ? label.textContent.replace(/\s+/g, ' ').trim() : (en ? 'Table' : 'جدول'));
      table.parentNode.insertBefore(box, table);
      box.appendChild(table);
    });
  }

  function onlyImage(p) {
    return p && p.tagName === 'P' && p.children.length === 1 && p.firstElementChild.tagName === 'IMG' && !p.textContent.trim();
  }

  function productCards(prose) {
    Array.prototype.slice.call(prose.children).forEach(function (p) {
      if (!onlyImage(p)) return;
      var next = p.nextElementSibling;
      var link = next && next.tagName === 'P' && next.firstElementChild;
      if (!link || link.tagName !== 'A' || !/\/products\//.test(link.getAttribute('href') || '')) return;
      var card = document.createElement('div');
      card.className = 'sedr-product';
      prose.insertBefore(card, p);
      card.appendChild(p.firstElementChild);
      card.appendChild(next);
      p.remove();
    });
  }

  function headingText(h) {
    return h.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function dropRelated(prose) {
    if (!document.querySelector('.sedr-more[data-related]')) return;
    var list = prose.querySelector('ul.sedr-related');
    if (!list) return;
    var head = list.previousElementSibling;
    if (head && head.tagName === 'H2') head.remove();
    list.remove();
  }

  function markSections(prose) {
    prose.querySelectorAll('h2').forEach(function (h) {
      var text = headingText(h);
      var list = h.nextElementSibling;
      if (!list) return;
      if (/^(اقرأ أيضًا|اقرأ أيضا|read also|read more|further reading|related reading|related articles)$/.test(text) && list.tagName === 'UL') {
        list.classList.add('sedr-related');
      }
      if (/^(المراجع|المصادر|references|sources)$/.test(text) && list.tagName === 'OL') {
        list.classList.add('sedr-refs');
        var after = list.nextElementSibling;
        while (after && after.tagName === 'P' && /^(إعداد وتحرير|كتبه|آخر مراجعة|آخر تحديث|prepared and edited by|written by|last reviewed|last updated)\s*:/i.test(after.textContent.trim())) {
          after.classList.add('sedr-signoff');
          after = after.nextElementSibling;
        }
        tidyRefs(list);
        foldRefs(list);
      }
    });
  }

  function tidyRefs(list) {
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    var dateRe = /\s*(?:تاريخ الاطلاع\s*:|Accessed)\s*([^.:]+?)\.?\s*$/;
    var items = Array.prototype.slice.call(list.children).filter(function (li) { return li.tagName === 'LI'; });
    var found = items.map(function (li, i) {
      var id = (li.id || '').match(/(\d+)$/);
      li.setAttribute('data-n', id ? id[1] : i + 1);
      li.dir = /^[^A-Za-z\u0600-\u06FF]*[A-Za-z]/.test(li.textContent) ? 'ltr' : 'rtl';
      var last = li.lastChild;
      var m = last && last.nodeType === 3 ? last.nodeValue.match(dateRe) : null;
      return m ? { node: last, match: m } : null;
    });
    // أكثر التواريخ تكرارًا يُكتب مرة تحت القائمة، ولا يُكتب تحت مرجع إلا ما خالفه
    var count = {};
    found.forEach(function (f) { if (f) count[f.match[1]] = (count[f.match[1]] || 0) + 1; });
    var common = Object.keys(count).sort(function (x, y) { return count[y] - count[x]; })[0];
    if (!common) return;
    var all = found.every(function (f) { return f && f.match[1] === common; });
    found.forEach(function (f) {
      if (!f) return;
      f.node.nodeValue = f.node.nodeValue.slice(0, f.match.index);
      if (f.match[1] === common) return;
      var span = document.createElement('span');
      span.className = 'sedr-ref-date';
      span.dir = en ? 'ltr' : 'rtl';
      span.textContent = (en ? 'Accessed ' : 'تاريخ الاطلاع: ') + f.match[1];
      f.node.parentNode.appendChild(span);
    });
    var p = document.createElement('p');
    p.className = 'sedr-refs-date';
    p.textContent = all
      ? (en ? 'All sources accessed ' : 'تاريخ الاطلاع على المراجع كلها: ') + common
      : (en ? 'Sources accessed ' + common + ', unless another date is given.' : 'تاريخ الاطلاع على المراجع: ' + common + '، إلا ما ذُكر تاريخه تحته.');
    list.parentNode.insertBefore(p, list.nextSibling);
  }

  function foldRefs(list) {
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    var n = list.querySelectorAll(':scope > li').length;
    var box = document.createElement('details');
    box.className = 'sedr-refs-box';
    var summary = document.createElement('summary');
    box.appendChild(summary);
    list.parentNode.insertBefore(box, list);
    box.appendChild(list);
    var date = box.nextElementSibling;
    if (date && date.classList.contains('sedr-refs-date')) box.appendChild(date);
    function label() {
      summary.textContent = box.open
        ? (en ? 'Hide sources' : 'إخفاء المراجع')
        : (en ? 'Show sources (' + n + ')' : 'عرض المراجع (' + n + ')');
    }
    label();
    box.addEventListener('toggle', label);

    // رقم الإحالة يفتح القائمة قبل الانتقال إلى مرجعه
    function target(href) {
      var id = (href || '').replace(/^.*#/, '');
      try { id = decodeURIComponent(id); } catch (e) {}
      var t = id && document.getElementById(id);
      return t && box.contains(t) ? t : null;
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a && target(a.getAttribute('href'))) box.open = true;
    });
    window.addEventListener('hashchange', function () {
      var t = target(location.hash);
      if (t && !box.open) { box.open = true; t.scrollIntoView({ block: 'start' }); }
    });
    var t = target(location.hash);
    if (t) { box.open = true; t.scrollIntoView({ block: 'start' }); }
  }

  function buildToc(prose) {
        var tpl = document.getElementById('sedr-toc-template');
    if (!tpl) return;
    var old = prose.querySelector('#accordion-container');
    if (!old) {
      var title = prose.querySelector('#accordion-title');
      old = title && (title.closest('details') || title.parentNode);
    }
    if (!old) return;
    var links = Array.prototype.slice.call(old.querySelectorAll('a[href^="#"]'));
    if (!links.length) return;

    function norm(s) {
      return (s || '').toLowerCase()
        .replace(/[ً-ٰٟـ]/g, '')
        .replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
        .replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim()
        .replace(/\b(frequently asked questions|common questions|faqs?)\b/g, 'faq');
    }
    var stop = ['the', 'and', 'of', 'in', 'for', 'to', 'an', 'في', 'من', 'على', 'عن', 'حول', 'مع'];
    function words(s) {
      return norm(s).split(' ').map(function (w) {
        return w.replace(/^(وال|بال|كال|فال|لل|ال)(?=\S\S)/, '');
      }).filter(function (w) { return w.length > 1 && stop.indexOf(w) < 0; });
    }
    function score(a, b) {
      if (norm(a) === norm(b)) return 1;
      var x = words(a), y = words(b);
      if (!x.length || !y.length) return 0;
      var common = x.filter(function (w) { return y.indexOf(w) > -1; }).length;
      var small = Math.min(x.length, y.length);
      if (common === small && small >= 2) return 0.9;
      return common / (x.length + y.length - common);
    }
    function targetOf(id) {
      var el = id && document.getElementById(id);
      return el && prose.contains(el) && !old.contains(el) ? el : null;
    }

    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2, h3, h4')).filter(function (h) { return !old.contains(h); });
    var items = links.map(function (a) {
      var id = a.getAttribute('href').slice(1);
      try { id = decodeURIComponent(id); } catch (e) {}
      return { id: id, text: a.textContent.replace(/\s+/g, ' ').trim(), target: null };
    });
    var used = [];
    items.forEach(function (it) { it.target = targetOf(it.id); if (it.target) used.push(it.target); });
    items.forEach(function (it) {
      if (it.target) return;
      var best = null, bestScore = 0.6;
      heads.forEach(function (h) {
        if (h.id || used.indexOf(h) > -1) return;
        var s = score(it.text, h.textContent);
        if (s > bestScore) { best = h; bestScore = s; }
      });
      if (best) { best.id = it.id; it.target = best; used.push(best); }
    });
    function between(h, a, b) {
      return (!a || (a.compareDocumentPosition(h) & 4)) && (!b || (h.compareDocumentPosition(b) & 4));
    }
    for (var i = 0; i < items.length; i++) {
      if (items[i].target || !items[i].text) continue;
      var j = i;
      while (j < items.length && !items[j].target) j++;
      var run = items.slice(i, j).filter(function (it) { return it.text; });
      var prev = null, next = j < items.length ? items[j].target : null;
      for (var k = i - 1; k >= 0 && !prev; k--) prev = items[k].target;
      var free = heads.filter(function (h) {
        return !h.id && used.indexOf(h) < 0 && h.textContent.trim() && between(h, prev, next);
      });
      if (free.length === run.length) {
        run.forEach(function (it, k) { free[k].id = it.id; it.target = free[k]; used.push(free[k]); });
      } else {
        run.forEach(function (it) {
          var num = it.text.match(/^\s*(\d+)\s*[.\-)]/);
          if (!num) return;
          var same = free.filter(function (h) {
            var m = h.textContent.match(/^\s*(\d+)\s*[.\-)]/);
            return m && m[1] === num[1] && !h.id;
          });
          if (same.length === 1) { same[0].id = it.id; it.target = same[0]; used.push(same[0]); }
        });
      }
      i = j;
    }

    var node = document.importNode(tpl.content, true).firstElementChild;
    var list = node.querySelector('.sedr-toc__list');
    var listed = [];
    var n = 0;
    items.forEach(function (it) {
      if (!it.target || !it.text || listed.indexOf(it.target) > -1) return;
      var own = /^H[1-6]$/.test(it.target.tagName) ? it.target.textContent.replace(/\s+/g, ' ').replace(/[\s:;،,]+$/, '').trim() : '';
      listed.push(it.target);
      var li = document.createElement('li');
      if (/^H[3-6]$/.test(it.target.tagName)) li.className = 'sedr-toc__sub';
      else li.value = ++n;
      var a = document.createElement('a');
      a.href = '#' + it.target.id;
      a.textContent = own || it.text;
      li.appendChild(a);
      list.appendChild(li);
    });
    if (!list.children.length) return;

    node.addEventListener('toggle', function () { node.setAttribute('aria-expanded', node.open ? 'true' : 'false'); });
    node.addEventListener('click', function (e) {
      var a = e.target.closest('.sedr-toc__list a');
      if (!a) return;
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + t.id);
      if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
      t.focus({ preventScroll: true });
    });
    old.replaceWith(node);

    var hash = location.hash.slice(1);
    try { hash = decodeURIComponent(hash); } catch (e) {}
    if (hash && items.some(function (it) { return it.target && it.target.id === hash; })) {
      document.getElementById(hash).scrollIntoView({ block: 'start' });
    }
  }

  function buildFaq(prose) {
    var tpl = document.getElementById('sedr-faq-template');
    if (!tpl) return;
    var all = Array.prototype.slice.call(prose.querySelectorAll('details')).filter(function (d) {
      return !d.matches('.accordion, .sedr-refs-box') && !d.closest('.accordion, .sedr-refs-box') && !d.querySelector('#accordion-title') &&
        d.querySelector(':scope > summary');
    });
    // المجموعة: details متجاورة لا يفصلها إلا فراغ
    var groups = [];
    all.forEach(function (d) {
      var last = groups[groups.length - 1];
      var prev = d.previousElementSibling;
      if (last && prev === last[last.length - 1]) last.push(d);
      else groups.push([d]);
    });
    groups.forEach(function (group) {
      var box = document.importNode(tpl.content, true).firstElementChild;
      var model = box.firstElementChild;
      box.removeChild(model);
      group.forEach(function (d) {
        var item = model.cloneNode(true);
        var summary = d.querySelector(':scope > summary');
        item.querySelector('.accordion__toggle span').textContent = summary.textContent.replace(/\s+/g, ' ').trim();
        var body = item.querySelector('.accordion__content .prose');
        Array.prototype.slice.call(d.childNodes).forEach(function (node) {
          if (node === summary) return;
          // تنسيق البطاقات القديم (حدود وهوامش) يُترك لتنسيق الأكورديون
          if (node.nodeType === 1) node.removeAttribute('style');
          body.appendChild(node);
        });
        if (d.open) {
          item.open = true;
          item.setAttribute('aria-expanded', 'true');
        }
        item.addEventListener('toggle', function () { item.setAttribute('aria-expanded', item.open ? 'true' : 'false'); });
        box.appendChild(item);
      });
      // غلاف قديم ليس فيه إلا الأسئلة (faq-container) يحل الصندوق محله
      var parent = group[0].parentElement;
      var only = parent !== prose && Array.prototype.every.call(parent.children, function (el) { return group.indexOf(el) > -1; });
      if (only) parent.replaceWith(box);
      else {
        group[0].before(box);
        group.forEach(function (d) { d.remove(); });
      }
    });
  }

  function buildRail(prose) {
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    var toc = prose.querySelector('.sedr-toc');
    var items = [];
    if (toc) {
      toc.querySelectorAll('.sedr-toc__list > li:not(.sedr-toc__sub) > a').forEach(function (a) {
        var t = document.getElementById(a.getAttribute('href').slice(1));
        if (t) items.push({ target: t, text: a.textContent });
      });
    } else {
      prose.querySelectorAll(':scope > h2').forEach(function (h, i) {
        if (!h.id) h.id = 'sedr-section-' + (i + 1);
        items.push({ target: h, text: h.textContent.replace(/\s+/g, ' ').trim() });
      });
    }
    if (items.length < 4) return;

    function go(it) {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      it.target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#' + it.target.id);
    }

    var nav = document.createElement('nav');
    nav.className = 'sedr-rail';
    nav.setAttribute('aria-label', en ? 'Article sections' : 'أقسام المقال');
    var list = document.createElement('ol');
    var links = items.map(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      var label = document.createElement('span');
      a.href = '#' + it.target.id;
      label.className = 'sedr-rail__label';
      label.textContent = it.text;
      a.appendChild(label);
      a.addEventListener('click', function (e) {
        e.preventDefault();
        go(it);
        a.blur();
      });
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });
    nav.appendChild(list);
    document.body.appendChild(nav);

    var bar = buildBar(items, en, go);
    var wide = window.matchMedia('(min-width: 1200px) and (hover: hover)');
    var current = -1, pending = false;
    function update() {
      pending = false;
      var vh = window.innerHeight;
      var start = (toc || prose).getBoundingClientRect()[toc ? 'bottom' : 'top'];
      var end = prose.getBoundingClientRect().bottom;
      var show = start < 0 && end > vh * .5;
      nav.classList.toggle('is-visible', show && wide.matches);
      var line = vh * .3;
      var tops = items.map(function (it) { return it.target.getBoundingClientRect().top; });
      var active = 0;
      tops.forEach(function (t, i) { if (t <= line) active = i; });
      if (!wide.matches) bar.update(show, active);
      if (active === current) return;
      if (current > -1) links[current].removeAttribute('aria-current');
      links[active].setAttribute('aria-current', 'true');
      current = active;
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  // زر الأقسام على الجوال: فوق زر «إلى الأعلى»، وبالنقر عليه قائمة الأقسام والحالي منها مميَّز
  function buildBar(items, en, go) {
    var nav = document.createElement('nav');
    nav.className = 'sedr-bar';
    nav.setAttribute('aria-label', en ? 'Article sections' : 'أقسام المقال');
    var panel = document.createElement('div');
    panel.className = 'sedr-bar__panel';
    panel.id = 'sedr-bar-panel';
    panel.hidden = true;
    var head = document.createElement('p');
    head.className = 'sedr-bar__head';
    head.textContent = en ? 'In this article' : 'في هذا المقال';
    var list = document.createElement('ol');
    panel.appendChild(head);
    panel.appendChild(list);
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'sedr-bar__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', panel.id);
    toggle.setAttribute('aria-label', en ? 'Article sections' : 'أقسام المقال');
    toggle.innerHTML = '<svg class="sedr-bar__icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M9 6.5h10.5M9 12h10.5M9 17.5h10.5"></path>' +
      '<circle cx="4.75" cy="6.5" r="1.25"></circle><circle cx="4.75" cy="12" r="1.25"></circle><circle cx="4.75" cy="17.5" r="1.25"></circle></svg>';

    var links = [], current = -1;
    items.forEach(function (it) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + it.target.id;
      a.textContent = it.text;
      a.addEventListener('click', function (e) {
        e.preventDefault();
        open(false);
        go(it);
      });
      li.appendChild(a);
      list.appendChild(li);
      links.push(a);
    });
    nav.appendChild(panel);
    nav.appendChild(toggle);
    document.body.appendChild(nav);

    function open(on) {
      panel.hidden = !on;
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      nav.classList.toggle('is-open', on);
      if (on && links[current]) links[current].scrollIntoView({ block: 'nearest' });
    }
    toggle.addEventListener('click', function () { open(panel.hidden); });
    document.addEventListener('click', function (e) { if (!panel.hidden && !nav.contains(e.target)) open(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !panel.hidden) { open(false); toggle.focus(); }
    });

    return {
      update: function (show, active) {
        nav.classList.toggle('is-visible', show);
        if (!show && !panel.hidden) open(false);
        if (active === current) return;
        if (current > -1) links[current].removeAttribute('aria-current');
        links[active].setAttribute('aria-current', 'true');
        current = active;
      }
    };
  }

  /* ---------- الرسم التفاعلي «طبقات العطر» (BLG-25، M61) ----------
     يُستدعى من init() بـ layersCharts(prose). الشكل والألوان من صورة الرسم 5 (حزمة perfume-visuals 1.2):
     المنحنيات بإحداثيات الصورة (عرضها 1600)، وأصل المحورين فيها عند (1430، 790)، والوقت يجري من اليمين إلى اليسار.
     المدد من Rodrigues وآخرين 2021 [1]: العليا 15–30 دقيقة، والقلب 3–4 ساعات، والقاعدة أكثر من 4 ساعات. */
  var LAYERS = [
    { name: 'نفحات القاعدة', short: 'القاعدة', ex: 'عنبر، مسك', dur: 'أكثر من 4 ساعات', color: '#2b251f', width: 3.2, arrow: true,
      segs: [[1430, 425, 1190, 435, 998, 465, 814, 517], [814, 517, 630, 569, 379, 589, 130, 628]] },
    { name: 'نفحات القلب', short: 'القلب', ex: 'توابل، زهور', dur: '3–4 ساعات', color: '#c3996c', width: 4,
      segs: [[1430, 425, 1277, 450, 1103, 494, 921, 594], [921, 594, 739, 694, 649, 742, 525, 779]] },
    { name: 'النفحات العليا', short: 'العليا', ex: 'حمضيات، روائح خضراء', dur: '15–30 دقيقة', color: '#dbc4a9', width: 4.5,
      segs: [[1430, 425, 1330, 454, 1293, 594, 1216, 699], [1216, 699, 1170, 759, 1124, 778, 1080, 779]] }
  ];

  /* الوقت u من 0 (الآن) إلى 1، والارتفاع v من 0 (المحور) إلى 1، بمقياس الصورة */
  var U0 = 1430, USPAN = 1320, V0 = 790, VSPAN = 405;
  var HALF = (U0 - 1080) / USPAN, FOUR = (U0 - 520) / USPAN, LATER = (U0 - 171) / USPAN, UMAX = LATER;
  var TICKS = [[0, 'الآن'], [HALF, 'نصف ساعة'], [FOUR, '4 ساعات'], [LATER, 'وما بعدها']];

  /* محطات المؤشر: كل خمس دقائق حتى نصف ساعة، ثم كل نصف ساعة حتى أربع ساعات، ثم ما بعدها.
     والمسافات بينها على مقياس الصورة، لا على مقياس واحد */
  var STOP_LABELS = {
    0: 'الآن', 5: 'بعد 5 دقائق', 10: 'بعد 10 دقائق', 15: 'بعد ربع ساعة', 20: 'بعد 20 دقيقة', 25: 'بعد 25 دقيقة',
    30: 'بعد نصف ساعة', 60: 'بعد ساعة', 90: 'بعد ساعة ونصف', 120: 'بعد ساعتين', 150: 'بعد ساعتين ونصف',
    180: 'بعد 3 ساعات', 210: 'بعد 3 ساعات ونصف', 240: 'بعد 4 ساعات', '-1': 'بعد أكثر من 4 ساعات'
  };

  function stopNote(m) {
    if (m < 0) return 'بقيت القاعدة وحدها.';
    if (m === 0) return 'الطبقات الثلاث حاضرة كلها.';
    if (m < 15) return 'الطبقات الثلاث حاضرة، والعليا أسرعها ذهابًا.';
    if (m < 30) return 'العليا تخفت سريعًا، والقلب والقاعدة باقيان.';
    if (m < 180) return 'غابت العليا في الغالب، وبقي القلب والقاعدة.';
    if (m < 240) return 'القلب يخفت، والقاعدة باقية.';
    return 'غاب القلب في الغالب، وبقيت القاعدة.';
  }

  var STOPS = [0, 5, 10, 15, 20, 25, 30, 60, 90, 120, 150, 180, 210, 240, -1].map(function (m) {
    var u = m < 0 ? .92 : m <= 30 ? m / 30 * HALF : HALF + (m - 30) / 210 * (FOUR - HALF);
    return { m: m, u: u, label: STOP_LABELS[m], note: stopNote(m) };
  });

  function nearestStop(u) {
    var best = 0;
    for (var i = 1; i < STOPS.length; i++) {
      if (Math.abs(STOPS[i].u - u) < Math.abs(STOPS[best].u - u)) best = i;
    }
    return best;
  }

  /* المنحنيات بمقياس u وv، ونهاية كل منها */
  LAYERS.forEach(function (L) {
    L.curves = L.segs.map(function (s) {
      var c = [];
      for (var i = 0; i < 8; i += 2) c.push((U0 - s[i]) / USPAN, (V0 - s[i + 1]) / VSPAN);
      return c;
    });
    L.end = L.curves[L.curves.length - 1][6];
  });

  function bez(a, b, c, d, t) {
    var s = 1 - t;
    return s * s * s * a + 3 * s * s * t * b + 3 * s * t * t * c + t * t * t * d;
  }

  /* ارتفاع المنحنى عند الوقت u، أو null بعد نهايته */
  function vAt(L, u) {
    if (u > L.end + 1e-6) return null;
    for (var k = 0; k < L.curves.length; k++) {
      var c = L.curves[k];
      if (u > c[6] + 1e-6) continue;
      var lo = 0, hi = 1;
      for (var n = 0; n < 24; n++) {
        var mid = (lo + hi) / 2;
        if (bez(c[0], c[2], c[4], c[6], mid) < u) lo = mid; else hi = mid;
      }
      return bez(c[1], c[3], c[5], c[7], (lo + hi) / 2);
    }
    return null;
  }

  var SVGNS = 'http://www.w3.org/2000/svg';

  function svgEl(name, attrs, parent) {
    var el = document.createElementNS(SVGNS, name);
    for (var k in attrs) el.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(el);
    return el;
  }

  function layersCharts(prose) {
    /* نص الرسم عربي، فلا يُبنى في الصفحة الإنجليزية وتبقى فيها الصورة */
    if (!('ResizeObserver' in window) || !/^ar/i.test(document.documentElement.lang || '')) return;
    prose.querySelectorAll('figure.sedr-fig[data-sedr-chart="layers"]').forEach(function (fig, n) {
      if (fig.dataset.sedrReady) return;
      fig.dataset.sedrReady = '1';
      layersChart(fig, n);
    });
  }

  function layersChart(fig, n) {
    var img = fig.querySelector('img');
    var id = 'sedr-layers-' + n;
    var hover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ink = 'rgb(43 37 31)';

    var root = document.createElement('div');
    root.className = 'sedr-layers';
    var order = LAYERS.slice().reverse();
    root.innerHTML =
      '<div class="sedr-layers__head">' +
        '<p class="sedr-layers__title">ما يبقى من طبقات العطر مع الوقت</p>' +
        '<p class="sedr-layers__sub">العليا تخفت أولًا، والقاعدة آخر ما يبقى</p>' +
      '</div>' +
      '<ul class="sedr-layers__legend">' + order.map(function (L) {
        return '<li style="--c:' + L.color + '"><span class="sedr-layers__name">' + L.name + '</span>' +
          '<span class="sedr-layers__ex">' + L.ex + '</span></li>';
      }).join('') + '</ul>' +
      '<div class="sedr-layers__now">' +
        '<p class="sedr-layers__hint">' + (hover ? 'حرّك المؤشر على الرسم لترى ما يبقى في كل وقت' : 'اسحب إصبعك على الرسم لترى ما يبقى في كل وقت') + '</p>' +
        '<p class="sedr-layers__readout" aria-hidden="true"></p>' +
      '</div>' +
      '<div class="sedr-layers__chart">' +
        '<div class="sedr-layers__plot"></div>' +
        '<p class="sedr-layers__axis">الوقت بعد وضع العطر<span class="sedr-layers__note">المسافات الزمنية تقريبية وغير خطية</span></p>' +
      '</div>' +
      '<ul class="sedr-layers__cards">' + order.map(function (L) {
        return '<li style="--c:' + L.color + '"><span class="sedr-layers__layer">' + L.short + '</span><strong class="sedr-layers__dur">' + L.dur + '</strong></li>';
      }).join('') + '</ul>';

    var plot = root.querySelector('.sedr-layers__plot');
    var now = root.querySelector('.sedr-layers__now');
    var readout = root.querySelector('.sedr-layers__readout');
    var svg = svgEl('svg', { role: 'img', 'aria-label': img ? img.alt : '' }, plot);
    var range = document.createElement('input');
    range.className = 'sedr-layers__range';
    range.type = 'range';
    range.min = 0;
    range.max = STOPS.length - 1;
    range.step = 1;
    range.value = 0;
    range.setAttribute('aria-label', 'الوقت بعد وضع العطر');
    plot.appendChild(range);

    fig.insertBefore(root, fig.querySelector('figcaption'));
    fig.classList.add('is-live');

    var g = {}, cur = 0, stop = -1, lastW = 0, tween = 0;

    function render(force) {
      var W = Math.round(plot.clientWidth);
      if (!W || (W === lastW && !force)) return;
      lastW = W;
      var narrow = W < 480;
      var fs = narrow ? 12.5 : 13.5;
      var yTop = narrow ? 30 : 34;
      var ph = Math.max(160, Math.min(240, W * .36));
      var ay = yTop + ph;
      var H = ay + (narrow ? 34 : 38);
      var ax = W - (narrow ? 14 : 18);
      var lx = 4;
      var S = ax - lx - 8;
      var px = function (u) { return ax - u * S; };
      var py = function (v) { return ay - v * ph; };

      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      svg.setAttribute('width', W);
      svg.setAttribute('height', H);
      svg.textContent = '';

      var defs = svgEl('defs', {}, svg);
      var mAxis = svgEl('marker', { id: id + '-ax', viewBox: '0 0 10 10', refX: 9, refY: 5, markerWidth: 9, markerHeight: 9,
        markerUnits: 'userSpaceOnUse', orient: 'auto' }, defs);
      svgEl('path', { d: 'M1 1L9 5L1 9', fill: 'none', stroke: ink, 'stroke-width': 1.6, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, mAxis);
      var as = narrow ? 14 : 17;
      var mBase = svgEl('marker', { id: id + '-base', viewBox: '0 0 10 10', refX: 8, refY: 5, markerWidth: as, markerHeight: as,
        markerUnits: 'userSpaceOnUse', orient: 'auto' }, defs);
      svgEl('path', { d: 'M1 1L8 5L1 9', fill: 'none', stroke: LAYERS[0].color, 'stroke-width': 32 / as, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, mBase);

      function label(text, x, y) {
        var t = svgEl('text', { x: x, y: y, 'font-size': fs, 'text-anchor': 'middle' }, svg);
        t.textContent = text;
        var w = t.getComputedTextLength();
        t.setAttribute('x', Math.max(lx + w / 2, Math.min(W - 1 - w / 2, x)));
        return { el: t, w: w };
      }

      /* خطا نصف الساعة والساعات الأربع */
      [HALF, FOUR].forEach(function (u) {
        svgEl('line', { x1: px(u), y1: yTop, x2: px(u), y2: ay, stroke: '#e2d9cf', 'stroke-width': 1.2, 'stroke-dasharray': '3 5' }, svg);
      });

      /* المحوران: الوقت إلى اليسار، وما يبقى إلى أعلى */
      svgEl('line', { x1: ax, y1: ay, x2: lx, y2: ay, stroke: ink, 'stroke-width': 1.5, 'marker-end': 'url(#' + id + '-ax)' }, svg);
      svgEl('line', { x1: ax, y1: ay, x2: ax, y2: yTop + 2, stroke: ink, 'stroke-width': 1.5, 'marker-end': 'url(#' + id + '-ax)' }, svg);
      TICKS.forEach(function (t) {
        var x = px(t[0]);
        svgEl('line', { x1: x, y1: ay, x2: x, y2: ay + 6, stroke: ink, 'stroke-width': 1.5 }, svg);
        label(t[1], x, ay + (narrow ? 23 : 25));
      });
      var yl = label('ما يبقى (نسبي)', ax, yTop - 6);
      yl.el.setAttribute('x', Math.min(W - 1 - yl.w / 2, ax + 6 - yl.w / 2));

      /* المنحنيات: القاعدة أولًا ثم القلب ثم العليا، كما في الصورة */
      LAYERS.forEach(function (L) {
        var d = '';
        L.curves.forEach(function (c, i) {
          if (!i) d += 'M' + px(c[0]).toFixed(1) + ' ' + py(c[1]).toFixed(1);
          d += 'C' + [2, 4, 6].map(function (j) { return px(c[j]).toFixed(1) + ' ' + py(c[j + 1]).toFixed(1); }).join(' ');
        });
        var a = { d: d, fill: 'none', stroke: L.color, 'stroke-width': L.width, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' };
        if (L.arrow) a['marker-end'] = 'url(#' + id + '-base)';
        svgEl('path', a, svg);
      });

      /* المؤشر: خط رأسي، ونقطة على كل منحنى، ومقبض على محور الوقت */
      g.cursor = svgEl('g', { 'aria-hidden': 'true' }, svg);
      g.line = svgEl('line', { y1: yTop, y2: ay, stroke: ink, 'stroke-opacity': .3, 'stroke-width': 1.5 }, g.cursor);
      g.dots = LAYERS.map(function (L) {
        return svgEl('circle', { r: 5.5, fill: L.color, stroke: ink, 'stroke-opacity': .55, 'stroke-width': 1.5 }, g.cursor);
      });
      g.knob = svgEl('g', {}, g.cursor);
      svgEl('circle', { r: 9.5, fill: ink }, g.knob);
      svgEl('path', { d: 'M-2.5 -3.5L-5.5 0L-2.5 3.5M2.5 -3.5L5.5 0L2.5 3.5', fill: 'none', stroke: '#f7f3ef', 'stroke-width': 1.6,
        'stroke-linecap': 'round', 'stroke-linejoin': 'round' }, g.knob);
      g.px = px;
      g.py = py;
      g.ay = ay;
      g.S = S;

      /* ارتفاع سطر الوقت على أطول نصوصه، فلا يقفز الرسم حين يتغير */
      now.style.minHeight = '';
      var tallest = 0;
      STOPS.forEach(function (s) {
        readout.innerHTML = '<strong>' + s.label + '</strong>، ' + s.note;
        tallest = Math.max(tallest, readout.offsetHeight);
      });
      now.style.minHeight = (now.offsetHeight - readout.offsetHeight + tallest) + 'px';
      var target = stop;
      stop = -1;
      place(cur, true);
      setStop(target < 0 ? nearestStop(cur) : target);
    }

    /* keep: الحركة ذاهبة إلى محطة معلومة، فيبقى السطر عليها ولا يتبع المؤشر في الطريق */
    function place(u, keep) {
      cur = Math.max(0, Math.min(UMAX, u));
      if (!g.cursor) return;
      var x = g.px(cur);
      g.line.setAttribute('x1', x);
      g.line.setAttribute('x2', x);
      LAYERS.forEach(function (L, i) {
        var v = vAt(L, cur);
        var dot = g.dots[i];
        dot.style.display = v === null ? 'none' : '';
        if (v !== null) {
          dot.setAttribute('cx', x);
          dot.setAttribute('cy', g.py(v));
        }
      });
      g.knob.setAttribute('transform', 'translate(' + x + ' ' + g.ay + ')');
      if (!keep) setStop(nearestStop(cur));
    }

    function setStop(i) {
      if (i === stop) return;
      stop = i;
      var s = STOPS[i];
      readout.innerHTML = '<strong>' + s.label + '</strong>، ' + s.note;
      range.value = i;
      range.setAttribute('aria-valuetext', s.label + '، ' + s.note);
    }

    /* ينقل المؤشر إلى المحطة i: السطر والقيمة يتغيران فورًا، والمؤشر ينزلق إليها */
    function glide(i) {
      cancelAnimationFrame(tween);
      setStop(i);
      var from = cur, to = STOPS[i].u;
      if (reduce || Math.abs(to - from) < .001) return place(to, true);
      var ms = Math.min(160, 40 + Math.abs(to - from) * 600), t0 = 0;
      tween = requestAnimationFrame(function step(now) {
        if (!t0) t0 = now;
        var k = Math.min(1, (now - t0) / ms);
        place(from + (to - from) * (1 - Math.pow(1 - k, 3)), true);
        if (k < 1) tween = requestAnimationFrame(step);
      });
    }

    function used() {
      root.classList.add('is-used');
    }

    function seek(i) {
      used();
      glide(Math.max(0, Math.min(STOPS.length - 1, i)));
    }

    function snap() {
      glide(nearestStop(cur));
    }

    function uFromX(clientX) {
      var r = plot.getBoundingClientRect();
      return (g.px(0) - (clientX - r.left) * lastW / r.width) / g.S;
    }

    /* اللمس: السحب الأفقي يحرّك المؤشر، والرأسي يترك الصفحة تتمرر. والنقرة تنقل إلى أقرب وقت،
       إلا إن جاءت لتوقف تمرير الصفحة */
    var drag = null, lastScroll = 0;
    window.addEventListener('scroll', function () { lastScroll = performance.now(); }, { passive: true });

    plot.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { id: e.pointerId, x0: e.clientX, y0: e.clientY, touch: e.pointerType !== 'mouse', locked: false,
        quiet: performance.now() - lastScroll > 250 };
      if (!drag.touch) {
        drag.locked = true;
        plot.setPointerCapture(e.pointerId);
        cancelAnimationFrame(tween);
        used();
        place(uFromX(e.clientX));
      }
    });

    plot.addEventListener('pointermove', function (e) {
      if (!drag) {
        if (e.pointerType === 'mouse' && hover) {
          cancelAnimationFrame(tween);
          used();
          place(uFromX(e.clientX));
        }
        return;
      }
      if (e.pointerId !== drag.id) return;
      if (!drag.locked) {
        var dx = Math.abs(e.clientX - drag.x0), dy = Math.abs(e.clientY - drag.y0);
        if (dy > 8 && dy >= dx) {
          drag = null;
          return;
        }
        if (dx <= 8) return;
        drag.locked = true;
        try { plot.setPointerCapture(e.pointerId); } catch (_) {}
        cancelAnimationFrame(tween);
        used();
      }
      place(uFromX(e.clientX));
    });

    function release(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag;
      drag = null;
      if (e.type === 'pointercancel') return snap();
      if (!d.locked) {
        if (d.quiet) seek(nearestStop(uFromX(e.clientX)));
      } else if (d.touch) {
        snap();
      }
    }

    plot.addEventListener('pointerup', release);
    plot.addEventListener('pointercancel', release);
    plot.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse' && !drag) snap();
    });

    /* لوحة المفاتيح: الوقت يجري إلى اليسار، فالسهم الأيسر يتقدم به */
    range.addEventListener('keydown', function (e) {
      var step = { ArrowLeft: 1, ArrowUp: 1, ArrowRight: -1, ArrowDown: -1, PageUp: 3, PageDown: -3,
        Home: -STOPS.length, End: STOPS.length }[e.key];
      if (step === undefined) return;
      e.preventDefault();
      seek(stop + step);
    });
    range.addEventListener('input', function () { seek(+range.value); });
    range.addEventListener('focus', function () {
      if (range.matches(':focus-visible')) plot.classList.add('is-focus');
    });
    range.addEventListener('blur', function () { plot.classList.remove('is-focus'); });

    new ResizeObserver(function () { render(); }).observe(plot);
    render(true);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { render(true); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
